import { parse, parseExpression } from "@babel/parser";
export function parseAsEstreeExpression(source) {
  return parseExpression(source, {
    plugins: ["estree", ["pipelineOperator", {
      proposal: "minimal"
    }]],
    attachComment: false
  });
}
export function parseAsEstree(source) {
  let {
    typescript
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const file = parse(source, {
    plugins: ["estree", typescript && "typescript"].filter(Boolean),
    strictMode: true,
    attachComment: false
  });
  const body = file.program.body;
  const jsNodes = typescript ? [] : body;
  if (typescript) {
    for (const node of body) {
      if (node.type.startsWith("TS")) {
        if (/Enum|Import|Export/.test(node.type)) {
          throw new SyntaxError(`Unsupported TypeScript syntax: ${node.type}`);
        }
      } else {
        jsNodes.push(node);
      }
    }
  }
  if (jsNodes.length === 0) {
    throw new SyntaxError("Function declaration not found");
  }
  if (jsNodes.length > 1 || jsNodes[0].type !== "FunctionDeclaration") {
    throw new SyntaxError(`Expect a single function declaration at top level, but received: ${jsNodes.map(node => `"${node.type}"`).join(", ")}`);
  }
  return jsNodes[0];
}
//# sourceMappingURL=parse.js.map